import { render, staticRenderFns } from "./InstructionsTab.vue?vue&type=template&id=5c2b5967&scoped=true&"
import script from "./InstructionsTab.vue?vue&type=script&lang=js&"
export * from "./InstructionsTab.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsTab.vue?vue&type=style&index=0&id=5c2b5967&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b5967",
  null
  
)

export default component.exports